export const implementationI18n = {
  implementation: {
    en: {
      ACTUAL_PLACEMENT: 'Actual placement',
      ADDRESS: 'Address',
      BACK: 'Back',
      BIOLOGICAL_FATHER_NOT_GUARDIAN: 'Biological father not guardian',
      BIOLOGICAL_MOTHER_NOT_GUARDIAN: 'Biological mother not guardian',
      CARER_TREATMENT_MANAGER_NAME: 'Carer/treatment manager name',
      CASE_MANAGERS: 'Case managers',
      CHILD_OR_YOUNG_PERSON: 'Child or young person',
      CHILD_OR_YOUNG_PERSONS_CONTACT_WITH_SOCIAL_SERVICES:
        "Child or young person's contact with social services",
      CITY: 'City',
      CLIENT_OBFUSCATED_NO_IMPLEMENTATION_PLAN:
        'The client has been obfuscated from our program. According to GDPR and current privacy regulations, the previous implementation plan has been removed.',
      COORDINATED_INDIVIDUAL_PLAN: 'Coordinated individual plan',
      CREATE: 'Create',
      CREATE_IMPLEMENTATION_PLAN: 'Create implementation plan',
      CREATE_IMPLEMENTATION_PLAN_ERROR:
        'An error occurred when creating the implementation plan',
      CREATE_IMPLEMENTATION_PLAN_SUCCESS: 'Implementation plan created',
      DATE: 'Date',
      DATE_OF_IMPLEMENTATION_PLAN_COMPLETION:
        'Date of implementation plan completion',
      DATE_OF_PLANNING_MEETING: 'Date of planning meeting',
      DETAILS: 'Details',
      DO_YOU_WANT_TO_CREATE_A_NEW_IMPLEMENTATION_PLAN:
        'It appears that there is currently no active implementation plan associated with the client. Would you like to initiate the creation of a new implementation plan? The newly created plan will automatically be associated with the client and archived under the client’s document section. If needed, you can return and make edits to the plan at any time.',
      EDUCATION: 'Education',
      EMAIL: 'Email',
      EMPLOYEE_ADDRESS: 'Employee address',
      EMPLOYEE_EMAIL: 'Employee email',
      EMPLOYEE_MUNICIPALITY_UNIT: 'Employee municipality unit',
      EMPLOYEE_PHONE: 'Employee phone',
      EXPLANATION: 'Explanation',
      FAILED_TO_UPDATE_IMPLEMENTATION_PLAN:
        'Failed to update implementation plan',
      FAMILY_HOME: 'Family home',
      FEELINGS_AND_BEHAVIOR: 'Feelings and behavior',
      FIRST_GUARDIAN: 'Guardian',
      FIRST_NAME: 'First name',
      GOALS_AND_MEASURES: 'Goals and measures',
      GUARDIANS: 'Guardians',
      GUARDIANS_PERCEPTION_OF_THE_INTERVENTIONS:
        "Guardian's perception of the interventions",
      HEALTH: 'Health',
      HOW_THE_CHILD_OR_YOUNG_PERSON_HAS_EXPRESSED_THEIR_OPINIONS:
        'How the child or young person has expressed their opinions',
      IMPLEMENTATION_PLAN: 'Implementation plan',
      IMPORTANT_INFORMATION: 'Important information',
      INFORMATION: 'Information',
      INTERVENTION: 'Intervention',
      INTERVENTIONS: 'Interventions',
      IS_THERE_A_ASSESSED_NEED_FOR_A_COORDINATED_INDIVIDUAL_PLAN:
        'Is there a assessed need for a coordinated individual plan?',
      LAST_NAME: 'Last name',
      LEGAL_GUARDIAN: 'Legal guardian',
      LEGAL_SUPPORT_AND_TYPE_OF_PLACEMENT:
        'Legal support and type of placement',
      LOCATION: 'Location',
      MEASURES_IF_THE_PARTY_REGAINS_CONSENT_TO_PLACEMENT:
        'Measures if the party regains consent to placement',
      MEASURES_TIME_FRAME_AND_RESPONSIBLE:
        'Measures, time frame and responsible',
      NEXT: 'Next',
      NO_ACTIVE_IMPLEMENTATION_PLAN: 'No active implementation plan',
      OTHER_SPECIFY_WHO: 'Other (specify who)',
      OVERALL_GOALS_OF_THE_CARE_PLAN_FOR_HEALTHCARE:
        'Overall goals of the care plan for healthcare',
      PARTICIPATING_IN_PLANNING_MEETING: 'Participating in planning meeting',
      PERCEPTION: 'Perception',
      PHONE: 'Phone',
      PLACEMENT: 'Placement',
      PLANNED_FOLLOW_UP_MEETING: 'Planned follow-up meeting',
      POSTCODE: 'Postcode',
      RESIDENTIAL_ADDRESS: 'Residential address',
      SECOND_GUARDIAN: 'Guardian 2',
      SHOW_PDF: 'Show PDF',
      SOCIAL_RELATIONSHIPS: 'Social relationships',
      SOCIAL_SECURITY_NUMBER: 'Social security number',
      SOCIAL_SERVICES: 'Social services',
      SPECIAL_DESIGNATED_GUARDIAN: 'Special designated guardian',
      SUPPORT_FOR_GUARDIANS: 'Support for guardians',
      THE_YOUNG_PERSONS_PERCEPTION_OF_THE_INTERVENTIONS:
        "The young person's perception of the interventions",
      TIME: 'Time',
      TRANSPARENCY: 'Transparency',
      UPDATED_IMPLEMENTATION_PLAN: 'Updated implementation plan',
      YOUNG_PERSONS_INFORMATION_ABOUT_INTERVENTIONS_EVALUATION:
        'Evaluation of the child/young person’s information about interventions',
    },
    'sv-SE': {
      ACTUAL_PLACEMENT: 'Aktuell placering/insats',
      ADDRESS: 'Adress',
      BACK: 'Tillbaka',
      BIOLOGICAL_FATHER_NOT_GUARDIAN: 'Biologisk far, ej vårdnadshavare',
      BIOLOGICAL_MOTHER_NOT_GUARDIAN: 'Biologisk mor, ej vårdnadshavare',
      CARER_TREATMENT_MANAGER_NAME: 'Vårdgivare/behandlingsansvariges namn',
      CASE_MANAGERS: 'Handläggare',
      CHILD_OR_YOUNG_PERSON: 'Barnet/den unge',
      CHILD_OR_YOUNG_PERSONS_CONTACT_WITH_SOCIAL_SERVICES:
        'Barnets/den unges kontakt med socialtjänsten',
      CITY: 'Stad',
      CLIENT_OBFUSCATED_NO_IMPLEMENTATION_PLAN:
        'Klienten har gallrats från vårt program. Enligt GDPR och aktuella sekretessbestämmelser har den tidigare genomförandeplanen tagits bort.',
      COORDINATED_INDIVIDUAL_PLAN: 'Samordnad individuell plan',
      CREATE: 'Skapa',
      CREATE_IMPLEMENTATION_PLAN: 'Skapa genomförandeplan',
      CREATE_IMPLEMENTATION_PLAN_ERROR:
        'Ett fel uppstod när genomförandeplanen skapades',
      CREATE_IMPLEMENTATION_PLAN_SUCCESS: 'Genomförandeplanen skapades',
      DATE: 'Datum',
      DATE_OF_IMPLEMENTATION_PLAN_COMPLETION:
        'Datum då genomförandeplanen färdigställdes',
      DATE_OF_PLANNING_MEETING: 'Datum för planeringsmöte',
      DETAILS: 'Detaljer',
      DO_YOU_WANT_TO_CREATE_A_NEW_IMPLEMENTATION_PLAN:
        'Det framgår att det för närvarande inte finns någon aktiv genomförandeplan kopplad till klienten. Skulle du vilja initiera skapandet av en ny genomförandeplan? Den nyskapade planen kommer att automatiskt associeras med klienten och arkiveras under klientens dokumentsektion. Vid behov kan du återvända och göra redigeringar i planen när som helst.',
      EDUCATION: 'Utbildning',
      EMAIL: 'E-postadress',
      EMPLOYEE_ADDRESS: 'Uppdragsgivarens adress',
      EMPLOYEE_EMAIL: 'Uppdragsgivares e-postadress',
      EMPLOYEE_MUNICIPALITY_UNIT: 'Uppdragsgivare (kommun och enhet)',
      EMPLOYEE_PHONE: 'Uppdragsgivares telefon',
      EXPLANATION: 'Förklaring',
      FAILED_TO_UPDATE_IMPLEMENTATION_PLAN:
        'Misslyckades med att uppdatera genomförandeplanen',
      FAMILY_HOME: 'Familjehem',
      FEELINGS_AND_BEHAVIOR: 'Känslor och beteende',
      FIRST_GUARDIAN: 'Vårdnadshavare',
      FIRST_NAME: 'Förnamn',
      GOALS_AND_MEASURES: 'Mål och eventuella delmål',
      GUARDIANS: 'Vårdnadshavare',
      GUARDIANS_PERCEPTION_OF_THE_INTERVENTIONS:
        'Vårdnadshavarens uppfattning om insatserna',
      HEALTH: 'Hälsa',
      HOW_THE_CHILD_OR_YOUNG_PERSON_HAS_EXPRESSED_THEIR_OPINIONS:
        'Hur barnet/den unge har framfört sina åsikter',
      IMPLEMENTATION_PLAN: 'Genomförandeplan',
      INFORMATION: 'Information',
      INTERVENTION: 'Insats',
      INTERVENTIONS: 'Insatser',
      IS_THERE_A_ASSESSED_NEED_FOR_A_COORDINATED_INDIVIDUAL_PLAN:
        'Bedöms det föreligga behov av en SIP?',
      LAST_NAME: 'Efternamn',
      LEGAL_GUARDIAN: 'God man',
      LEGAL_SUPPORT_AND_TYPE_OF_PLACEMENT: 'Lagstöd och typ av placering',
      LOCATION: 'Plats',
      MEASURES_IF_THE_PARTY_REGAINS_CONSENT_TO_PLACEMENT:
        'Åtgärder om part återtar samtycke till placering',
      MEASURES_TIME_FRAME_AND_RESPONSIBLE: 'Insats, tidsram och ansvarig',
      NEXT: 'Nästa',
      NO_ACTIVE_IMPLEMENTATION_PLAN: 'Ingen aktiv genomförandeplan',
      OTHER_SPECIFY_WHO: 'Övriga, ange vem',
      OVERALL_GOALS_OF_THE_CARE_PLAN_FOR_HEALTHCARE:
        'Vårdplanens övergripande mål för vården',
      PARTICIPATING_IN_PLANNING_MEETING:
        'Delaktiga i upprättande av genomförandeplanen',
      PERCEPTION: 'Uppfattning',
      PHONE: 'Telefon',
      PLACEMENT: 'Placering',
      PLANNED_FOLLOW_UP_MEETING: 'Planerat uppföljningsmöte',
      POSTCODE: 'Postkod',
      RESIDENTIAL_ADDRESS: 'Folkbokföringsadress',
      SECOND_GUARDIAN: 'Vårdnadshavare 2',
      SHOW_PDF: 'Visa PDF',
      SOCIAL_RELATIONSHIPS: 'Sociala relationer',
      SOCIAL_SECURITY_NUMBER: 'Personnummer',
      SOCIAL_SERVICES: 'Socialtjänsten',
      SPECIAL_DESIGNATED_GUARDIAN: 'Särskilt förordnad vårdnadshavare',
      SUPPORT_FOR_GUARDIANS: 'Stöd till vårdnadshavare',
      THE_YOUNG_PERSONS_PERCEPTION_OF_THE_INTERVENTIONS:
        'Barnets/den unges uppfattning om insatserna',
      TIME: 'Tid',
      TRANSPARENCY: 'Insyn',

      UPDATED_IMPLEMENTATION_PLAN: 'Genomförandeplanen uppdaterades',
      YOUNG_PERSONS_INFORMATION_ABOUT_INTERVENTIONS_EVALUATION:
        'Utvärdering av barnet/den unges information om insatser',
    },
  },
};
